import {
  GetUserById,
  NewUser,
  UpdateUser,
  User,
  UserCreated,
  UserUpdated,
  type GetAllUsers,
  type GetMyUser,
} from '@/model/user'
import { wsClient } from '@/plugins/axios'
import { plainToInstance } from 'class-transformer'

export const userRepository = {
  async getAllUsers() {
    const { data } = await wsClient.get<GetAllUsers>('/users')
    return plainToInstance(User, data.users)
  },
  async getMyUser() {
    const { data } = await wsClient.get<GetMyUser>('/users/me')
    return { user: plainToInstance(User, data.user), userPermissions: data.userPermissions }
  },
  async getUserById(userId: string) {
    const { data } = await wsClient.get<GetUserById>(`/users/${userId}`)
    return plainToInstance(User, data.user)
  },
  async createUser(newUser: NewUser) {
    const { data } = await wsClient.post<UserCreated>('/users', newUser)
    return plainToInstance(User, data.user)
  },
  async updateUser(userId: string, updateUser: UpdateUser) {
    const { data } = await wsClient.patch<UserUpdated>(`/users/${userId}`, updateUser)
    return plainToInstance(User, data.user)
  },
}
